<template>
    <div class="comments-list-section hide-native-scrollbar fx-grow-1">
        <div v-if="data.list.length > 0">
            <Comment
                v-for="comment in data.list"
                :data="comment"
                :key="comment.id"
            >
            </Comment>
        </div>
        <div v-else class="dp-fx fx-al-ct fx-js-ct wd-full ht-full">
            <div class="dp-fx fx-dr-col fx-al-ct comments-status">
                <img src="@/assets/drawer.png" width="60" height="60" alt="Drawer Icon" />
                <div class="fz-14 fw-7 tx-ct mg-t-10">{{data.status}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Comment from "@/components/Comment.vue";

    export default {
        name : 'CommentsList',
        components : {
            Comment : Comment
        },
        props : {
            data : Object
        },
        data : function () {
            return {

            }
        },
        methods : {

        }
    }
</script>

<style>
    .comments-list-section{
        overflow-y: scroll;
    }
</style>